import { Box, Button, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { setSiteUser } from 'reduxLib/slices/userSlice'
import { refreshCurrentUser } from 'utils/subscription'

export default function SubscriptionSuccess() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    const syncUser = async () => {
      for (let attempt = 0; attempt < 10; attempt += 1) {
        const response = await refreshCurrentUser(dispatch, setSiteUser)
        if (response?.data?.has_subscription) {
          break
        }
        await new Promise((resolve) => setTimeout(resolve, 1000))
      }
      if (!cancelled) {
        setLoading(false)
      }
    }

    syncUser()
    return () => {
      cancelled = true
    }
  }, [dispatch])

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="90vh">
      <Box bgcolor="white" p={3} borderRadius="10px" width="100%" maxWidth={520}>
        <Typography fontSize={22} fontWeight={700} mt={2} textAlign="center">
          Paiement confirmé
        </Typography>
        <Typography textAlign="center" color="gray" mt={1}>
          {loading
            ? 'Mise à jour de votre abonnement...'
            : 'Votre abonnement a bien été synchronisé. Vous pouvez continuer dans l’application.'}
        </Typography>
        <Box mt={3} display="flex" justifyContent="center">
          <Button onClick={() => navigate('/')} sx={{ fontSize: 18, px: 9 }} variant="contained" disabled={loading}>
            Continuer
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
